/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { kebabCase } from 'lodash';
import { string } from 'prop-types';

const HeaderIcon = ({
  label = '',
  classType = kebabCase(label),
  icon: Icon, // React requires elements to be uppercase when used as <Elements>
  metricsLabelText = kebabCase(label),
  metricsLabelType = label === 'Download' ? 'download' : 'other',
  classPrefix = 'header-icon',
  to,
  internal,
  dataTestId,
  ...htmlAProps
}) => {
  return (
    <Fragment>
      {!internal && (
        <a
          data-metrics-link-text={metricsLabelText}
          data-metrics-link-type={metricsLabelType}
          className={`${classPrefix}-${classType}-container`}
          {...htmlAProps}
          data-testid={dataTestId}
        >
          <Icon className={`${classPrefix}-${classType}-icon`} />
          <span className={`${classPrefix}-${classType}-title`}>{label}</span>
        </a>
      )}
      {internal && (
        <NavLink to={to} className={`${classPrefix}-${classType}-container`}>
          <Icon className={`${classPrefix}-${classType}-icon`} />
          <span className={`${classPrefix}-${classType}-title`}>{label}</span>
        </NavLink>
      )}
    </Fragment>
  );
};

HeaderIcon.propTypes = {
  label: string.isRequired,
  classPrefix: string
};

export default HeaderIcon;
